export default class Cascader {

  /**
   * @param {...Object} objects
   */
  constructor(...objects) {
    this._objects = objects;
  }

  /**
   * @param {string} key
   */
  get(key) {
    for (let i = 0; i < this._objects.length; i++) {
      let value = this._get(key, 0, this._objects[i]);
      if (value) {
        return {
          value,
          depth: i
        }
      }
    }
    return null;
  }

  /**
   * @param {string} key
   * @param {number} index
   * @param {Object} object
   */
  _get(key, index, object) {
    let keys = key.split(".");
    if (typeof object[keys[index]] !== "undefined" && object[keys[index]] !== null) {
      if (index < keys.length - 1) {
        return this._get(key, index + 1, object[keys[index]]);
      }
      return object[keys[index]];
    }
    return null;
  }

}